import CompaniesModule from '@/modules/company';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/companies/')({
  component: CompaniesPage,
});

function CompaniesPage() {
  return <CompaniesModule />;
}
